@import '../../theme/global';

snap-checkbox-button {
  align-items: center;
  cursor: pointer;
  display: flex;
  min-height: 48px;
  position: relative;
  text-align: left;
  @include set-font;
  @include box-sizing;
  @include reset-inputs;


  @media (min-width: map-get($breakpoints, 'md')) {
    min-height: auto;
  }

  .snap-checkbox-button {
    display: flex;
  }

  p {
    margin: 0;
  }

  &.disabled {
    cursor: initial;

    .label {
      cursor: initial;
    }
  }

  .input-wrapper {
    align-items: center;
    display: flex;
    height: 1.25rem;
    margin-right: 0.5rem;
    order: 0;
  }

  .label-wrapper {
    font-size: 0.875rem;
    line-height: 1.25rem;
    order: 1;

    &.inline {
      display: flex;
    }

    &.right {
      order: initial;
    }
  }

  .label {
    align-items: center;
    color: $gray-800;
    cursor: pointer;
    display: flex;
    font-weight: 500;

    snap-icon {
      margin-left: 0.625rem;
    }
  }

  .required {
    color: $red-500;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin-left: 0.125rem;
  }

  &.disabled:not(.selected) {
    .label {
      color: $gray-500;
    }

    .description {
      color: $gray-400;
    }
  }

  .input {
    appearance: none;
    background-color: $base-light;
    background-origin: border-box;
    border-color: $gray-300;
    border-radius: 0.25rem;
    border-width: 1px;
    color: $blue-600;
    color-adjust: exact;
    cursor: pointer;
    display: inline-block;
    flex-shrink: 0;
    height: 1rem;
    padding: 0;
    -webkit-print-color-adjust: exact;
    user-select: none;
    vertical-align: middle;
    width: 1rem;

    --tw-shadow: 0 0 #0000;

    &:hover:not([disabled]) {
      border: 1px solid $blue-600;
      box-shadow: 0 0 0 1px $blue-600;
    }

    &.locked:checked {
      background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='%2394A3B8' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
    }

    &.error {
      border-color: $red-500;
    }

    &.partial {
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='10' height='2' viewBox='0 0 10 2' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.322327 0.291775C0.115791 0.478734 -0.000149884 0.732393 1.45424e-07 0.996969C0.000238471 1.26155 0.116552 1.51534 0.323363 1.70255C0.530174 1.88976 0.81022 1.99524 1.1025 1.99545L8.89864 2C9.19092 2.00014 9.47114 1.89518 9.67767 1.70823C9.88421 1.52127 10.0001 1.26761 10 1.00303C9.99976 0.738455 9.88345 0.484656 9.67664 0.297448C9.46983 0.11024 9.18945 0.00495197 8.89717 0.00473615L1.10136 1.31637e-07C0.809083 -0.000135675 0.528864 0.104815 0.322327 0.291775Z' fill='%232563EB'/%3E%3C/svg%3E");
      background-position: center;
      background-repeat: no-repeat;
    }

    &.locked.partial {
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='10' height='2' viewBox='0 0 10 2' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.322327 0.291775C0.115791 0.478734 -0.000149884 0.732393 1.45424e-07 0.996969C0.000238471 1.26155 0.116552 1.51534 0.323363 1.70255C0.530174 1.88976 0.81022 1.99524 1.1025 1.99545L8.89864 2C9.19092 2.00014 9.47114 1.89518 9.67767 1.70823C9.88421 1.52127 10.0001 1.26761 10 1.00303C9.99976 0.738455 9.88345 0.484656 9.67664 0.297448C9.46983 0.11024 9.18945 0.00495197 8.89717 0.00473615L1.10136 1.31637e-07C0.809083 -0.000135675 0.528864 0.104815 0.322327 0.291775Z' fill='%2394A3B8'/%3E%3C/svg%3E");
      background-position: center;
      background-repeat: no-repeat;
    }
  }

  .description {
    color: $gray-500;

    &.error {
      color: $red-600;
    }

    span {
      @include sr-only;
    }
  }

  & input[type='checkbox'][disabled] {
    background-color: $gray-100;
    background-image: none;
    border: 1px solid $gray-300;
    cursor: not-allowed;

    .label {
      color: $gray-500;
    }
  }

  &[checkbox-side='right'] {
    justify-content: space-between;
    width: 100%;

    .label-wrapper {
      margin-left: 0;
      margin-right: 0.75rem;
    }
  }

  [type='checkbox']:checked {
    background-color: $blue-600;
    background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
  }

  [type='checkbox']:focus-visible {
    box-shadow: 0 0 0 2px #fff, 0 0 0 4px #3b82f6;
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
}
